import Axios from "axios";

class VeranstaltungService {

    alle = null;

    getAllUpcomingEvents = () => {

        return new Promise((resolve, reject) => {
            if (this.alle != null) {
                resolve(this.alle);
            } else {
                Axios.get("/api/veranstaltungen").then(res => {
                    console.log("events: ", res);
                    this.alle = res.data;
                    resolve(this.alle);
                }).catch(err => {
                    console.log(err);
                    reject(err);
                });
            }
        });
    }

    getById = (id) => {
        return new Promise((resolve, reject) => {
            if (this.alle != null) {
                resolve(this.alle.filter(el => el.id === id)[0]);
            } else {
                this.getAllUpcomingEvents().then(res => {
                    resolve(res.filter(el => el.id === id)[0])
                }).catch(err => {
                    reject(err);
                });
            }
        });
    }
}


const VeranstaltungServiceInstance = new VeranstaltungService();
export default VeranstaltungServiceInstance;



// WEBPACK FOOTER //
// ./src/services/VeranstaltungService.js